//FUNCIONS
import React from 'react';

//HOOKS
import { useAccount } from '../hooks/hooksAccount';

//TYPES

//COMPONENTS
import AccountDataData from './AccountDataData';
import AccountDataPassword from './AccountDataPassword';

//STYLES

const AccountData: React.FC = () => {
  const { openViewPassword } = useAccount()

  return (
    <>
      {openViewPassword ? <AccountDataPassword /> : <AccountDataData />}
    </>
  )
}

export default AccountData;
